var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPopUpRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Functional / ic_pop_up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.99887471,5 C8.27501708,5 8.49887471,5.22385763 8.49887471,5.5 C8.49887471,5.77614237 8.27501708,6 7.99887471,6 L4.5,6 C3.67157288,6 3,6.67157288 3,7.5 L3,19.5 C3,20.3284271 3.67157288,21 4.5,21 L16.5,21 C17.3284271,21 18,20.3284271 18,19.5 L18,16.0036469 C18,15.7275045 18.2238576,15.5036469 18.5,15.5036469 C18.7761424,15.5036469 19,15.7275045 19,16.0036469 L19,19.5 C19,20.8807119 17.8807119,22 16.5,22 L4.5,22 C3.11928813,22 2,20.8807119 2,19.5 L2,7.5 C2,6.11928813 3.11928813,5 4.5,5 L7.99887471,5 Z M9.5,14 C9.77614237,14 10,14.2238576 10,14.5 L10,17.5 C10,17.7761424 9.77614237,18 9.5,18 C9.22385763,18 9,17.7761424 9,17.5 L9,15.708 L5.85608504,18.8538168 C5.66089114,19.0491472 5.34430867,19.0492578 5.1489783,18.8540639 C4.95364793,18.65887 4.95353729,18.3422875 5.14873119,18.1469572 L8.294,15 L6.5,15 C6.22385763,15 6,14.7761424 6,14.5 C6,14.2238576 6.22385763,14 6.5,14 L9.5,14 Z M19.5,2 C20.8807119,2 22,3.11928813 22,4.5 L22,11.5 C22,12.8807119 20.8807119,14 19.5,14 L12.5,14 C11.1192881,14 10,12.8807119 10,11.5 L10,4.5 C10,3.11928813 11.1192881,2 12.5,2 L19.5,2 Z M19.5,3 L12.5,3 C11.6715729,3 11,3.67157288 11,4.5 L11,11.5 C11,12.3284271 11.6715729,13 12.5,13 L19.5,13 C20.3284271,13 21,12.3284271 21,11.5 L21,4.5 C21,3.67157288 20.3284271,3 19.5,3 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-34.000000, -150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Line-3",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Functional-/-ic_pop_up",
    transform: "translate(32.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_pop_up",
    fill: "#CC0000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPopUpRed);
export default __webpack_public_path__ + "static/media/ic_pop_up_red.9ed063eeed64e21d5dae1151510a616d.svg";
export { ForwardRef as ReactComponent };